<template>
  <div>
    <div
      class="justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
    >
      <div class="row">
        <h1 class="h2 text-muted">
          ADMINISTRATION / USER ACCOUNT / {{ full_name }}
        </h1>
      </div>
      <div class="row" style="justify-content: flex-end;">
        <div class="col-2">
          <button
            type="button"
            class="btn btn-danger"
            id="disbut"
            data-bs-toggle="modal"
            data-bs-target="#removeModal"
          >
            Remove
          </button>
        </div>
        <div class="col-2">
          <button
            type="button"
            class="btn btn-primary"
            id="savebut"
            @click="save"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
    <form class="row g-3">
      <div class="col-md-7">
        <label for="fullname" class="form-label">Full Name</label>
        <input
          class="form-control"
          id="fullname"
          v-model="full_name"
          disabled
        />
      </div>
      <div class="col-md-5">
        <label for="accname" class="form-label">Account Name</label>
        <input
          class="form-control"
          id="accname"
          disabled
          v-model="account_name"
        />
      </div>
      <div class="col-md-7">
        <label for="loginname" class="form-label">Username</label>
        <input
          class="form-control"
          id="loginname"
          v-model="username"
          disabled
        />
      </div>
      <div class="col-md-5">
        <label for="secret" class="form-label">Key</label>
        <!-- <input class="form-control" id="key" disabled v-model="key" /> -->
        <div class="input-group mb-2">
          <input
            type="text"
            class="form-control"
            id="key"
            v-model="key"
            readonly
          />
          <button
            class="btn btn-outline-secondary"
            type="button"
            @click="generateKey"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-arrow-clockwise"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
              />
              <path
                d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"
              />
            </svg>
          </button>
          <button
            class="btn btn-outline-secondary"
            type="button"
            @click="copySecret"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-clipboard"
              viewBox="0 0 16 16"
            >
              <path
                d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
              />
              <path
                d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
              />
            </svg>
          </button>
        </div>
      </div>
      <div class="col-md-7">
        <label for="email" class="form-label">Email</label>
        <input class="form-control" id="email" v-model="email" disabled />
      </div>
      <div class="col-md-7">
        <label for="password" class="form-label col-7">Password</label>
        <div class="input-group mb-3">
          <input
            type="password"
            class="form-control"
            id="password"
            placeholder="••••••••"
            disabled
            aria-describedby="button-addon2"
            v-model="password"
          />
          <button
            class="btn btn-outline-secondary"
            type="button"
            id="chgbut"
            @click="chgpwd"
          >
            Change
          </button>
        </div>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          name="flexRadioDefault"
          id="active"
          value="active"
          v-model="active"
        />
        <label class="form-check-label" for="flexRadioDefault1">
          Account Active
        </label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          name="flexRadioDefault"
          id="disabled"
          value="disabled"
          v-model="active"
        />
        <label class="form-check-label" for="flexRadioDefault2">
          Account Disabled
        </label>
      </div>
    </form>
    <!-- Modal -->
    <div
      class="modal fade"
      id="removeModal"
      tabindex="-1"
      aria-labelledby="removeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Remove Account
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="confirmDelete = ''"
            ></button>
          </div>
          <div class="modal-body">
            <div
              class="alert alert-danger d-flex align-items-center"
              role="alert"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                viewBox="0 0 16 16"
                role="img"
                aria-label="Warning:"
              >
                <path
                  d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                />
              </svg>
              <div>
                Warning: This action cannot be un-done!
              </div>
            </div>
            <div class="row mb-3">
              <label for="confirmDelete" class="col-sm-8 col-form-label"
                >Are you sure you want to remove this account? (Type yes to
                confirm)</label
              >
              <div class="col-sm-4">
                <input
                  class="form-control"
                  id="confirmDelete"
                  v-model="confirmDelete"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              @click="confirmDelete = ''"
            >
              Close
            </button>
            <button
              id="myBtn"
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click="discard"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="forceRemoveModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="forceRemoveModalLabel">
              Force Remove Account
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="confirmDelete = ''"
            ></button>
          </div>
          <div class="modal-body">
            This account is currently being used by someone else. Are you sure
            you still want to remove?
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              @click="confirmDelete = ''"
            >
              No
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click="forceRemove"
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="lastUserModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="forceRemoveModalLabel">
              Last User Account
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            This is the last user account and hence, cannot be deleted.
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click="$router.push('/users')"
            >
              Okay
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import config from "../../config";
export default {
  data() {
    return {
      user_id: 0,
      full_name: "",
      username: "",
      email: "",
      active: "",
      password: "",
      account_name: "",
      key: "",
      confirmDelete: "",
    };
  },
  methods: {
    async getDeets() {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            userId: this.$route.params.id,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/get_single_user",
        requestOptions
      );
      const data = await response.json();
      console.log(data);
      if (data == null) this.$router.push("/error");
      this.full_name = data["full_name"];
      this.username = data["username"];
      this.email = data["email"];
      this.account_name = data["account_name"];
      this.key = data["key"];
      if (data["active"]) {
        this.active = "active";
      } else {
        this.active = "disabled";
      }
    },
    async generateKey() {
      const res = await axios.get(config.baseURL + "/generate_secret_code");
      console.log(res.data["secret_code"]);
      this.key = res.data["secret_code"];
    },
    copySecret() {
      var copyText = document.getElementById("key");
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand("copy");
      // alert("Successfully copied secret token!");
    },
    chgpwd() {
      $("#password").removeAttr("disabled");
      $("#password").removeAttr("placeholder");
    },
    isActive() {
      if (this.active === "active") {
        return true;
      } else {
        return false;
      }
    },
    async save() {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            userId: parseInt(this.$route.params.id),
            account_name: this.account_name,
            key: this.key,
            password: this.password,
            active: this.isActive(),
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/update_user",
        requestOptions
      );
      const data = await response.json();
      console.log(data);
      this.$router.push("/users");
    },
    async discard() {
      if (this.confirmDelete.toLowerCase() === "yes") {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              userId: parseInt(this.$route.params.id),
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/remove_user",
          requestOptions
        );
        const data = await response.json();
        console.log(data);
        if (data["Completed"]) this.$router.push("/users");
        else if (data["last_user"]) $("#lastUserModal").modal("show");
        else $("#forceRemoveModal").modal("show");
      } else {
        this.confirmDelete = "";
      }
    },
    async forceRemove() {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            userId: parseInt(this.$route.params.id),
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/force_remove_user",
        requestOptions
      );
      const data = await response.json();
      console.log(data);
      if (data["Completed"]) this.$router.push("/users");
    },
  },
  mounted() {
    this.getDeets();
    var input = document.getElementById("confirmDelete");
    input.addEventListener("keyup", function(event) {
      if (event.key === "Enter") {
        event.preventDefault();
        document.getElementById("myBtn").click();
      }
    });
  },
};
</script>

<style>
#disbut {
  float: right;
}
</style>
